import { TicketAnalyticsView } from '../../components/analytics/TicketAnalyticsView'

function AgentAnalytics() {
  return <TicketAnalyticsView />
}

export default AgentAnalytics
